import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { AiToneOfVoicesQuery } from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";
import { REACT_QUERY_OPTIONS_NEVER_REFETCH } from "../utils";

const aiToneOfVoicesQuery = graphql(`
  query aiToneOfVoices {
    aiToneOfVoices {
      results {
        id
        label
        rawValue
        isDefault
        companyId
        teamId
        createdAt
        updatedAt
      }
    }
  }
`);

export type AiToneOfVoice = AiToneOfVoicesQuery["aiToneOfVoices"]["results"][number];

export function useAiToneOfVoices(
  options?: UseQueryOptions<AiToneOfVoicesQuery, unknown, AiToneOfVoicesQuery, QueryKey>,
) {
  const { data, ...rest } = useGraphQlQuery(["aiToneOfVoices"], aiToneOfVoicesQuery, [{}], {
    ...REACT_QUERY_OPTIONS_NEVER_REFETCH,
    ...options,
  });

  return { data: data?.aiToneOfVoices.results, ...rest };
}
